import * as React from 'react';
import { Command as CommandPrimitive } from 'cmdk';
import { cn } from '@core/helpers/misc/GeneralUtils';
import { InputGroup, InputGroupAddon, InputGroupInput } from '../input-group';

interface CommandInputProps extends React.ComponentPropsWithoutRef<typeof CommandPrimitive.Input> {
  wrapperClassName?: string;
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
}

const CommandInput = React.forwardRef<React.ElementRef<typeof CommandPrimitive.Input>, CommandInputProps>(
  ({ className, wrapperClassName, leading, trailing, onValueChange, ...props }, ref) => (
    <div className={cn('px-2 pb-2 pt-2', wrapperClassName)}>
      <InputGroup className='w-full'>
        {leading ? <InputGroupAddon className='pr-1'>{leading}</InputGroupAddon> : null}
        <CommandPrimitive.Input asChild ref={ref} onValueChange={onValueChange}>
          <InputGroupInput
            className={cn('', className)}
            {...props}
            onChange={(e) => {
              onValueChange?.(e.target.value);
            }}
          />
        </CommandPrimitive.Input>
        {trailing ? (
          <InputGroupAddon align='inline-end' className='pl-1'>
            {trailing}
          </InputGroupAddon>
        ) : null}
      </InputGroup>
    </div>
  )
);

CommandInput.displayName = CommandPrimitive.Input.displayName;

export { CommandInput };
